import { actionTypes } from 'actions/actionTypes'
import { isBillingAddressDifferent } from 'routes/Checkout/utils/state'

import {
  sectionName as billingAddressSection,
  deliveryAddressSectionName as deliveryAddressSection,
} from '../config'

export const transformBillingAddress = ({ houseNo, street, postcode, town }) => ({
  addressLine1: houseNo,
  addressLine2: street,
  postcode,
  city: town,
})

export const getBillingAddress = (formValues) => {
  const sectionName = isBillingAddressDifferent(formValues, billingAddressSection)
    ? billingAddressSection
    : deliveryAddressSection

  return formValues && formValues[sectionName]
    ? transformBillingAddress(formValues[sectionName])
    : {}
}

export const getErrorType = (errorCode) => {
  if (errorCode === '82031') {
    return actionTypes.CARD_TOKENIZATION_FAILED
  }

  return actionTypes.NETWORK_FAILURE
}
